const plans = [
  {
    id: "P-7YW74855TW9180828NGPGWMA", //Digi-Ants Exporter Pro - Promotion 5
    name: "Digi-Ants Exporter Pro for Revit - Annual Subscription",
    description:
      "Exporting PDF, DWG and other formats from Revit models. With autonomous and batch processing.",
    base_price: 39.0,
    promotion_id: "PROMO5",
    priceRanges: [
      {
        starting_quantity: "1",
        ending_quantity: "4",
        amount: {
          currency_code: "USD",
          value: "39.0",
        },
      },
      {
        starting_quantity: "5",
        ending_quantity: "9",
        amount: {
          currency_code: "USD",
          value: "35.1",
        },
      },
      {
        starting_quantity: "10",
        ending_quantity: "14",
        amount: {
          currency_code: "USD",
          value: "31.2",
        },
      },
      {
        starting_quantity: "15",
        ending_quantity: "19",
        amount: {
          currency_code: "USD",
          value: "27.3",
        },
      },
      {
        starting_quantity: "20",
        amount: {
          currency_code: "USD",
          value: "23.4",
        },
      },
    ],
  },

  {
    //Site Modeller Pro - Promotion 5: P-7WD67560A6907891KNGPGY4Y
    id: "P-7WD67560A6907891KNGPGY4Y",
    name: "Site Modeller Pro for Revit - Annual Subscription",
    description:
      "Support modelling Site and Landscape in Revit. Drastically reduce the time to create and edit site models.",
    base_price: 199.9,
    promotion_id: "PROMO5",
    priceRanges: [
      {
        starting_quantity: "1",
        ending_quantity: "4",
        amount: {
          currency_code: "USD",
          value: "199.9",
        },
      },
      {
        starting_quantity: "5",
        ending_quantity: "9",
        amount: {
          currency_code: "USD",
          value: "179.91",
        },
      },
      {
        starting_quantity: "10",
        ending_quantity: "14",
        amount: {
          currency_code: "USD",
          value: "159.92",
        },
      },
      {
        starting_quantity: "15",
        ending_quantity: "19",
        amount: {
          currency_code: "USD",
          value: "139.93",
        },
      },
      {
        starting_quantity: "20",
        amount: {
          currency_code: "USD",
          value: "119.94",
        },
      },
    ],
  },

  {
    id: "P-40A7776738827415TNGPG4ZA", //Quick Pipe Slope - Promotion 5
    name: "Quick Pipe Slope for Civil 3D - Annual Subscription",
    description:
      "Quickly and easily edit pipe slopes in your Civil 3D drawings. It is perfect for anyone who needs to make quick adjustments to their pipe slopes without having to manually edit one by one.",
    base_price: 24.99,
    promotion_id: "PROMO5",
    priceRanges: [
      {
        starting_quantity: "1",
        ending_quantity: "4",
        amount: {
          currency_code: "USD",
          value: "24.99",
        },
      },
      {
        starting_quantity: "5",
        ending_quantity: "9",
        amount: {
          currency_code: "USD",
          value: "22.49",
        },
      },
      {
        starting_quantity: "10",
        ending_quantity: "14",
        amount: {
          currency_code: "USD",
          value: "19.99",
        },
      },
      {
        starting_quantity: "15",
        ending_quantity: "19",
        amount: {
          currency_code: "USD",
          value: "17.49",
        },
      },
      {
        starting_quantity: "20",
        amount: {
          currency_code: "USD",
          value: "14.99",
        },
      },
    ],
  },

  {
    id: "P-7DN92922BE452784YNGPGUFA", //Bulk Etransmit - Promotion 5
    name: "Bulk Etransmit for AutoCAD - Annual Subscription",
    description:
      "Create Etransmit for multiple drawings at once. Save time and effort.",
    base_price: 19.99,
    promotion_id: "PROMO5",
    priceRanges: [
      {
        starting_quantity: "1",
        ending_quantity: "4",
        amount: {
          currency_code: "USD",
          value: "19.99",
        },
      },
      {
        starting_quantity: "5",
        ending_quantity: "9",
        amount: {
          currency_code: "USD",
          value: "17.99",
        },
      },
      {
        starting_quantity: "10",
        ending_quantity: "14",
        amount: {
          currency_code: "USD",
          value: "15.99",
        },
      },
      {
        starting_quantity: "15",
        ending_quantity: "19",
        amount: {
          currency_code: "USD",
          value: "13.99",
        },
      },
      {
        starting_quantity: "20",
        amount: {
          currency_code: "USD",
          value: "11.99",
        },
      },
    ],
  },

  {
    id: "P-35D49419KD0881236NGPGQYI", //Block Attribute Editor and PDF Publisher - Promotion 5
    name: "Block Attribute Editor and PDF Publisher for AutoCAD - Annual Subscription",
    description:
      "Editing Block Attribute and export to PDF. Many other features are includes to help working with blocks and their attributes much easier.",
    base_price: 39.99,
    promotion_id: "PROMO5",
    priceRanges: [
      {
        starting_quantity: "1",
        ending_quantity: "4",
        amount: {
          currency_code: "USD",
          value: "49.99",
        },
      },
      {
        starting_quantity: "5",
        ending_quantity: "9",
        amount: {
          currency_code: "USD",
          value: "44.99",
        },
      },
      {
        starting_quantity: "10",
        ending_quantity: "14",
        amount: {
          currency_code: "USD",
          value: "39.99",
        },
      },
      {
        starting_quantity: "15",
        ending_quantity: "19",
        amount: {
          currency_code: "USD",
          value: "34.99",
        },
      },
      {
        starting_quantity: "20",
        amount: {
          currency_code: "USD",
          value: "29.99",
        },
      },
    ],
  },

  {
    id: "P-87D33496T1341524BNGPG2YY", //Sheet Set Publisher and Property Editor - Promotion 5
    name: "Sheet Set Publisher and Property Editor for AutoCAD - Annual Subscription",
    description: " Publishing Sheet Set and editing its properties with ease.",
    base_price: 29.99,
    promotion_id: "PROMO5",
    priceRanges: [
      {
        starting_quantity: "1",
        ending_quantity: "4",
        amount: {
          currency_code: "USD",
          value: "29.99",
        },
      },
      {
        starting_quantity: "5",
        ending_quantity: "9",
        amount: {
          currency_code: "USD",
          value: "26.99",
        },
      },
      {
        starting_quantity: "10",
        ending_quantity: "14",
        amount: {
          currency_code: "USD",
          value: "23.99",
        },
      },
      {
        starting_quantity: "15",
        ending_quantity: "19",
        amount: {
          currency_code: "USD",
          value: "20.99",
        },
      },
      {
        starting_quantity: "20",
        amount: {
          currency_code: "USD",
          value: "17.99",
        },
      },
    ],
  },

  {
    id: "P-13152034BG990182LNGPGKVA", //Sheet Set Revision Manager - Promotion 5
    name: "Sheet Set Revision Manager for AutoCAD - Annual Subscription",
    description:
      "Support managing sheet's revisions when working with Sheet Set in AutoCAD",
    base_price: 29.99,
    promotion_id: "PROMO5",
    priceRanges: [
      {
        starting_quantity: "1",
        ending_quantity: "4",
        amount: {
          currency_code: "USD",
          value: "29.99",
        },
      },
      {
        starting_quantity: "5",
        ending_quantity: "9",
        amount: {
          currency_code: "USD",
          value: "26.99",
        },
      },
      {
        starting_quantity: "10",
        ending_quantity: "14",
        amount: {
          currency_code: "USD",
          value: "23.99",
        },
      },
      {
        starting_quantity: "15",
        ending_quantity: "19",
        amount: {
          currency_code: "USD",
          value: "20.99",
        },
      },
      {
        starting_quantity: "20",
        amount: {
          currency_code: "USD",
          value: "17.99",
        },
      },
    ],
  },

  {
    id: "P-9N497209D3867592HNGPG67I", //Sheet Set Manager Bundle - Promotion 5
    name: "Sheet Set Manager Bundle - Annual Subscription",
    description:
      "This bundle includes Sheet Set Publisher and Property Editor, and Sheet Set Revision Manager for AutoCAD. This will help you to manage your sheet sets and revisions in AutoCAD easily.",
    base_price: 45.0,
    promotion_id: "PROMO5",
    priceRanges: [
      {
        starting_quantity: "1",
        ending_quantity: "4",
        amount: {
          currency_code: "USD",
          value: "45.0",
        },
      },
      {
        starting_quantity: "5",
        ending_quantity: "9",
        amount: {
          currency_code: "USD",
          value: "40.5",
        },
      },
      {
        starting_quantity: "10",
        ending_quantity: "14",
        amount: {
          currency_code: "USD",
          value: "36.0",
        },
      },
      {
        starting_quantity: "15",
        ending_quantity: "19",
        amount: {
          currency_code: "USD",
          value: "31.5",
        },
      },
      {
        starting_quantity: "20",
        amount: {
          currency_code: "USD",
          value: "27.0",
        },
      },
    ],
  },
];

export default plans;
